import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-right-side-products',
  templateUrl: './right-side-products.component.html',
  styleUrls: ['./right-side-products.component.scss']
})
export class RightSideProductsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
